import { Injectable, Inject } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { User } from './user.model';
import { SnackService } from '../../shared-services/snack.service';
import { SecurityService } from '../security.service';
import { BackendService } from '../../core/backend.service';

@Injectable()
export class PerfilUserResolver implements Resolve<User> {
  constructor(
    protected router: Router,
    protected snackService: SnackService,
    protected securityService: SecurityService,
    protected backendService: BackendService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      return await this.backendService.get(User, User.path + 'perfil').toPromise();
    } catch (error) {
      this.router.navigate(['/home']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/security/user/perfilUser.resolver.ts